import { FormControl } from '@angular/forms';

export const licencePlateValidator = (control: FormControl) => {
  const hasError = control.value && !(/^[a-z]{2}\d{3}[a-z]{2}$|^[a-z]{3}\d{3}$/i.test(control.value))

  return (hasError) ? { invalidLicencePlate: true } : null;
};
